<template>
  <div class="basic">
    <page-header />
    <page-prompt />
    <audit-temp :audit_status="audit_status" :audit_remark="audit_remark" />
    <section class="main">
      <h2 class="title">基本信息</h2>
      <div class="form">
        <el-form label-position="top">
          <el-form-item label="姓名" :required="true">
            <el-input v-model="basic.contact" placeholder="请填写姓名..." :disabled="inputDisabled" />
          </el-form-item>
          <el-form-item label="身份证号" :required="true">
            <el-input v-model="basic.identity" placeholder="请填写身份证号..." :disabled="inputDisabled" />
          </el-form-item>
          <el-form-item label="学校" :required="true">
            <el-input v-model="basic.school_name" placeholder="请填写学校名称..." :disabled="inputDisabled" />
          </el-form-item>
          <el-form-item label="通讯地址" :required="true">
            <el-input type="textarea" v-model="basic.address" :rows="4" placeholder="请填写通讯地址..."
              :disabled="inputDisabled" />
          </el-form-item>
          <el-form-item label="邮政编码" :required="true">
            <el-input v-model="basic.zipcode" placeholder="请填写邮政编码..." :disabled="inputDisabled" />
          </el-form-item>
          <el-form-item label="团队名称" :required="true">
            <el-input v-model="basic.name" placeholder="请填写团队名称..." :disabled="inputDisabled" />
            <div class="tishi">团队名称可使用中英文，名称长度为4-30个字符。禁止使用特殊字符，队名中不允许出现学校或单位信息，例如“农大”</div>
          </el-form-item>
          <el-form-item label="所在城市" :required="true">
            <el-select v-model="basic.city_type" placeholder="请选择所在城市" style="width:100%;" :disabled="inputDisabled">
              <el-option v-for="item of city_type_config" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛区" :required="true">
            <el-select v-model="basic.area_type" placeholder="请选择赛区" style="width:100%;" :disabled="inputDisabled">
              <el-option v-for="item of area_type_config" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选题类别" :required="true">
            <el-select v-model="basic.topic_type" placeholder="请选择选题类别" style="width:100%;" :disabled="inputDisabled">
              <el-option v-for="item of topic_type_config" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参赛组别" :required="true">
            <el-select v-model="basic.student_type" placeholder="请选择参赛组别" style="width:100%;" :disabled="inputDisabled">
              <el-option v-for="item of student_type_config" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-right" @click="onNextPage">{{ inputDisabled ? '下一项' : '保存进行下一项'
          }}</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import PagePrompt from '@/components/PagePrompt'
import { fetchBasic, setBasic } from '@/service/api'

export default {
  name: 'PageBasic',
  components: {
    PageHeader,
    PagePrompt,
    AuditTemp
  },
  data () {
    return {
      city_type_config: [],
      area_type_config: [],
      topic_type_config: [],
      student_type_config: [],
      audit_status: 3,
      audit_remark: '',
      reg_preliminary_expire: false,
      basic: {
        contact: '',
        identity: '',
        school_name: '',
        address: '',
        zipcode: '',
        name: '',
        city_type: '',
        area_type: '',
        topic_type: '',
        student_type: ''
      }
    }
  },
  computed: {
    inputDisabled () {
      return this.audit_status === 2 || this.audit_status === 4 || this.audit_status === 5 || this.reg_preliminary_expire
    }
  },
  methods: {
    async getBasic () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        const data = await fetchBasic()
        const basic = data.team_basic
        this.reg_preliminary_expire = data.reg_preliminary_expire
        this.audit_status = basic.audit_status
        this.audit_remark = basic.audit_remark

        this.city_type_config = data.city_type_config
        this.area_type_config = data.area_type_config
        this.topic_type_config = data.topic_type_config
        this.student_type_config = data.student_type_config

        this.basic.contact = basic.contact || ''
        this.basic.identity = basic.identity || ''
        this.basic.school_name = basic.school_name || ''
        this.basic.address = basic.address || ''
        this.basic.zipcode = basic.zipcode || ''
        this.basic.name = basic.name || ''
        this.basic.city_type = basic.city_type || this.city_type_config[0].id
        this.basic.area_type = basic.area_type || this.area_type_config[0].id
        this.basic.topic_type = basic.topic_type || this.topic_type_config[0].id
        this.basic.student_type = basic.student_type || this.student_type_config[0].id
        loading.close()
      } catch (error) {
        loading.close()
        console.log('getBasic error', error)
      }
    },
    async onNextPage () {
      if (!this.basic.contact) {
        this.$alert(`请填写姓名`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.basic.identity || this.basic.identity.length !== 18) {
        this.$alert(`请正确填写身份证号`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.basic.school_name) {
        this.$alert(`请填写学校名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.basic.address) {
        this.$alert(`请填写通讯地址`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.basic.zipcode) {
        this.$alert(`请填写邮政编码`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (!this.basic.name || this.basic.name.length < 4 || this.basic.name.length > 30) {
        this.$alert(`请正确填写团队名称`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })

      try {
        await setBasic(this.basic)
        loading.close()
        this.$router.push('/team')
      } catch (error) {
        loading.close()
        console.log('setBasic error', error)
      }
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getBasic()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
